import {serializable, alias, primitive, object} from 'serializr';
import {BoardModel} from "../BoardModel/board.model";

export class ClassroomModel{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('name', primitive()))
    name?: string;
    @serializable(alias('amount_paise', primitive()))
    amountPaise?: string;
    @serializable(alias('amount_rupees', primitive()))
    amountRupees?: string;
    @serializable(alias('amount', primitive()))
    amount?: number;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('class_room_subject_count', primitive()))
    subjectCount?: number;
    @serializable(alias('board', object(BoardModel)))
    board?: string;
}
